<template>
  <v-card>
    <v-card-title class="justify-center">
      <span v-if="formType == 'addForm' " class="text-h5">{{ $t('Adding a new User') }}</span>
      <span v-if="formType == 'editForm' " class="text-h5">{{ $t('Edit User') }}</span>
      <span v-if="formType == 'viewForm' " class="text-h5">{{ $t('User Details') }}</span>
    </v-card-title>
      <v-container
        id="user-view"
        fluid
        tag="section"
      >
        <v-row justify="center">
          <v-col
            cols="12"
            md="12"
          >
            <material-card
              color="primary"
              icon="mdi-application"
            >
              <template #title>
                {{ $t('User') }}
              </template>

              <v-form>
                <v-container class="py-0">

                  <v-row>
                    <v-col 
                      cols="12" 
                      md="6"
                    >
                      <v-text-field
                        v-if="form_type == 'addForm' || form_type == 'editForm'"
                        v-model="data.username"
                        color="purple"
                        :label="$t('Username')"
                        :hint="$t('Mandatory')"
                        :rules="nameRules"
                        persistent-hint
                      />
                      <div v-if="form_type == 'viewForm'">
                        <p>{{ $t('Username') }}</p>
                        <p class="text-h4 text--primary">{{ user.username }}</p>
                      </div>
                    </v-col>
                    <v-col 
                      cols="12" 
                      md="6"
                    >
                      <v-text-field
                        v-if="form_type == 'addForm'"
                        v-model="data.password"
                        color="purple"
                        :label="$t('New Password')"
                        :hint="$t('Mandatory')"
                        :rules="nameRules"
                        persistent-hint
                      />
                      <v-text-field
                        v-if="form_type == 'editForm'"
                        v-model="data.password"
                        color="purple"
                        :label="$t('New Password')"
                      />
                    </v-col>
                  </v-row>  

                  <v-row>
                    <v-col 
                      cols="12" 
                      md="12"
                    >
                      <v-text-field
                        v-if="form_type == 'addForm' || form_type == 'editForm'"
                        v-model="data.first_name"
                        color="purple"
                        :label="$t('First Name')"
                        :hint="$t('Mandatory')"
                        :rules="nameRules"
                        persistent-hint
                      />
                      <div v-if="form_type == 'viewForm'">
                        <p>{{ $t('First Name') }}</p>
                        <p class="text-h4 text--primary">{{ user.first_name }}</p>
                      </div>
                    </v-col>
                  </v-row>  

                  <v-row>
                    <v-col 
                      cols="12" 
                      md="12"
                    >
                      <v-text-field
                        v-if="form_type == 'addForm' || form_type == 'editForm'"
                        v-model="data.last_name"
                        color="purple"
                        :label="$t('Last Name')"
                        :hint="$t('Mandatory')"
                        :rules="nameRules"
                        persistent-hint
                      />
                      <div v-if="form_type == 'viewForm'">
                        <p>{{ $t('Last Name') }}</p>
                        <p class="text-h4 text--primary">{{ user.last_name }}</p>
                      </div>
                    </v-col>
                  </v-row>  

                  <v-row>
                    <v-col 
                      cols="12" 
                      md="12"
                    >
                      <v-text-field
                        v-if="form_type == 'addForm' || form_type == 'editForm'"
                        v-model="data.mail"
                        color="purple"
                        :label="$t('Mail')"
                        :hint="$t('Mandatory')"
                        :rules="nameRules"
                        persistent-hint
                      />
                      <div v-if="form_type == 'viewForm'">
                        <p>{{ $t('Mail') }}</p>
                        <p class="text-h4 text--primary">{{ user.mail }}</p>
                      </div>
                    </v-col>
                  </v-row>  

                  <v-row>  
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-select
                        v-if="form_type == 'addForm' || form_type == 'editForm'"
                        v-model="data.user_profile_id"
                        :items="userProfileList"
                        :item-value="item=>item.id"
                        :item-text="item=>item.translation.name"
                        :label="$t('User Profile')"
                        :hint="$t('Mandatory')"
                        :rules="selectRules"
                        persistent-hint
                      >
                        <template v-slot:item="{ item }">
                          <div>{{ getTranslation(item.translation.name) }}</div>
                        </template>
                      </v-select>
                      <div v-if="form_type == 'viewForm'">
                        <p>{{ $t('User Profile') }}</p>
                        <p class="text-h4 text--primary" v-if="user.user_profile_id !== null">{{ getTranslation(user.user_profile.translation.name) }}</p>
                        <p class="text-h4 text--primary" v-if="user.user_profile_id === null"> / </p>
                      </div>
                    </v-col>
                  </v-row>

                  <v-row v-if="data.user_profile_id && data.user_profile_id !== 1">  
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-select
                        v-if="form_type == 'addForm' || form_type == 'editForm'"
                        v-model="provinceId"
                        :items="provinceList"
                        :item-value="item=>item.id"
                        :item-text="item=>item.translation.name"
                        :label="$t('Province')"
                        :hint="$t('Mandatory')"
                        :rules="selectRules"
                        persistent-hint
                      >
                        <template v-slot:item="{ item }">
                          <div>{{ getTranslation(item.translation.name) }}</div>
                        </template>
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row v-if="form_type == 'viewForm' && user.province_id !== null">
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <div v-if="form_type == 'viewForm'">
                          <p>{{ $t('Province') }}</p>
                          <p class="text-h4 text--primary" v-if="user.province_id !== null">{{ getTranslation(user.province.translation.name) }}</p>
                          <p class="text-h4 text--primary" v-if="user.province_id === null"> / </p>
                        </div>
                    </v-col>
                  </v-row>  

                  <v-row v-if="data.user_profile_id && data.user_profile_id === 3">  
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-select
                        v-if="form_type == 'addForm' || form_type == 'editForm'"
                        v-model="projectOwnerId"
                        :items="projectOwnerList"
                        :item-value="item=>item.id"
                        :item-text="item=>item.translation.name"
                        :label="$t('Project Owner')"
                        :hint="$t('Mandatory')"
                        :rules="selectRules"
                        persistent-hint
                      >
                        <template v-slot:item="{ item }">
                          <div>{{ getTranslation(item.translation.name) }}</div>
                        </template>
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row v-if="form_type == 'viewForm' && user.project_owner_id !== null">
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <div v-if="form_type == 'viewForm'">
                        <p>{{ $t('Project Owner') }}</p>
                        <p class="text-h4 text--primary" v-if="user.project_owner_id !== null">{{ getTranslation(user.project_owner.translation.name) }}</p>
                        <p class="text-h4 text--primary" v-if="user.project_owner_id === null"> / </p>
                      </div>
                    </v-col>
                  </v-row>  

                  <v-row>
                    <v-col 
                      cols="12" 
                      md="6"
                    >
                      <v-menu
                        v-if=" form_type == 'addForm' || form_type == 'editForm' "
                        v-model="beginDateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="beginDate"
                            :label="$t('Beginning Date')"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="beginDate"
                          @input="beginDateMenu = false"
                        >
                        </v-date-picker>
                      </v-menu>
                      <div v-if="form_type == 'viewForm'">
                        <p>{{ $t('Beginning Date') }}</p>
                        <p class="text-h4 text--primary">{{ new Date(user.beginning_date).toLocaleDateString("en-GB") }}</p>
                      </div>
                    </v-col>
                    <v-col 
                      cols="12" 
                      md="6"
                    >
                      <v-menu
                        v-if=" form_type == 'addForm' || form_type == 'editForm' "
                        v-model="endDateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="endDate"
                            :label="$t('Ending Date')"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="endDate"
                          @input="endDateMenu = false"
                        >
                        </v-date-picker>
                      </v-menu>
                      <div v-if="form_type == 'viewForm'">
                        <p>{{ $t('Ending Date') }}</p>
                        <p class="text-h4 text--primary">{{ new Date(user.ending_date).toLocaleDateString("en-GB") }}</p>
                      </div>
                    </v-col>
                  </v-row> 

                  <v-row>  
                    <table>
                      <thead>
                        <tr>
                          <td>{{ $t('Function') }}</td>
                          <td>{{ $t('User Right') }}</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(fct,id) in functionList" :key="fct.id">
                          <td><div>{{ fct.translation.name }}</div></td>
                          <td><div>
                            <v-select
                              v-if="form_type == 'addForm' || form_type == 'editForm'"
                              v-model="data.user_functions[id].user_type_id"
                              :items="userTypeList"
                              :item-value="item=>item.id"
                              :item-text="item=>item.translation.name"
                              :label="$t('Access Type')"
                            >
                              <template v-slot:item="{ item }">
                                <div>{{ getTranslation(item.translation.name) }}</div>
                              </template>
                            </v-select>
                          </div>
                          <div v-if="form_type == 'viewForm'">
                            <span class="text-h4 text--primary">{{ user.user_functions[id].user_type.translation.name }}</span>
                          </div>
                        </td>
                        </tr>
                      </tbody>
                    </table>
                  </v-row>
                  
                  <v-row>

                  </v-row>
                </v-container>
              </v-form>
            </material-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions v-if="form_type == 'addForm' || form_type == 'editForm'">
      <v-spacer></v-spacer>
      <v-btn
        class="close-button"
        text
        v-on:click="close_edit()"
      >
        {{ $t('Close') }}
        <v-dialog v-model="dialog_modal_message" persistent max-width="800px" :retain-focus="false">
          <MessageAlert 
              v-if="dialog_modal_message" 
              :messageProps="$store.state.messages.close" 
              :cancelProps="$store.state.messages.no" 
              :validationProps="$store.state.messages.yes" 
              :dialog.sync="dialog_modal_message" 
              @answerModal="getModalAnswer"
          />
        </v-dialog>
      </v-btn>
      <v-btn
        color="white darken-1"
        style="background-color:#31c0be;"
        text
        v-on:click="save()"
        v-if="data 
              && data.username
              && (form_type == 'addForm' && data.password  || form_type == 'editForm') 
              && data.first_name
              && data.last_name
              && data.mail
              && (data.user_profile_id === 1
                    || (data.user_profile_id === 2 && provinceId !== null)
                    || (data.user_profile_id === 3 && projectOwnerId !== null) 
                  )
              && beginDate
              && endDate
              && beginDate < endDate"
      >
        {{ $t('Save') }}
      </v-btn>
    </v-card-actions>
    <v-card-actions v-if="form_type == 'viewForm'">
      <v-spacer></v-spacer>
      <v-btn
        class="close-button"
        text
        v-on:click="close()"
      >
        {{ $t('Close') }}
      </v-btn>
      <v-btn 
          class="small" 
          color="success" 
          v-if="$store.state.auth.user.user_functions[10].user_type_id !== 1"
          v-on:click="update(user)" >
        <v-icon>mdi-update</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: 'UserForm',
    props: {
      user: {
        type: Object
      },
      formType: {
        type: String
      },
     
    },
    data: () => ({
      dialog_modal_message: false,
      form_type: '',
      data: {
        user_functions: []
      },
      beginDateMenu: false,
      endDateMenu: false,
      beginDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      endDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      provinceId: null,
      projectOwnerId: null
    }),
    computed: {
        functionList() {
          return this.$store.state.referentials.functionList;
        },
        userTypeList() {
          return this.$store.state.referentials.userTypeList;
        },
        userProfileList() {
          return this.$store.state.referentials.userProfileList;
        },
        provinceList() {
          return this.$store.state.referentials.provinceList;
        },
        projectOwnerList() {
          return this.$store.state.projects.projectOwnerList;
        }
    },
    created: function(){
      //https://v15.vuetifyjs.com/en/components/forms/ 
      this.nameRules = [ v => !!v || this.getTranslation('Name is required') ];
      this.numberRules = [ v => v > 0 || this.getTranslation('Positive Number is required') ];
      this.selectRules = [ v => !!v || this.getTranslation('At least 1 Information is required') ];
    },
    mounted: function(){

      this.form_type = this.formType;
      this.$store.dispatch('referentials/getFunctionList');
      this.$store.dispatch('referentials/getUserProfileList');
      this.$store.dispatch('referentials/getUserTypeList');
      this.$store.dispatch('referentials/getProvinceList');
      this.$store.dispatch('projects/getProjectOwnerList');
    },
    watch: {
      functionList(){
        if(this.form_type == 'addForm'){
          for(var i=0; i < this.functionList.length; i++){
            var obj = {
                'function_id': this.functionList[i].id,
                'user_type_id': 4
              }
            this.data.user_functions.push(obj);
          }
        }
      },
      'data.user_profile_id': function(){
        if(this.data.user_profile_id === 1){
          this.projectOwnerId = null;
          this.provinceId = null;
          //this.data.province_id = null;
          //this.data.project_owner_id = null;
        }else if(this.data.user_profile_id === 2){
          this.projectOwnerId = null;
          //this.data.project_owner_id = null;
        }
      },
      projectOwnerId: function(value){
        //console.log('*****projectOwnerId', value);
        this.data.project_owner_id = value;
      },
      provinceId: function(value){
        //console.log('****provinceId', value);
        this.data.province_id = value;
      },
      //NE MARCHE PAS
      /*'data.province_id': function(){
        console.log('*****data.province_id', this.data.province_id);
        this.data.province_id = value;
      },
      'data.province_id': function(value, next){
        console.log('*****data.province_id', this.data.province_id);
        this.data.province_id = value;
      },
      'data.project_owner_id': function(value, next){
        this.data.project_owner_id = value;
      }*/
    },
    methods: {
      getHeader(val) {
        return this.$t(val);
      },
      getTranslation(val) {
        return this.$t(val);
      },
      update: function(val){
        this.form_type = 'editForm';
        this.data = val;
        //console.log('val', val);
        this.projectOwnerId = val.project_owner_id;
        this.provinceId = val.province_id;
        this.beginDate = val.beginning_date.substr(0, val.beginning_date.indexOf('T'));
        this.endDate = val.ending_date.substr(0, val.ending_date.indexOf('T'));
      },
      close: function(){
        this.$store.dispatch('user/getUserList');
        this.$emit('update:dialog', false)
      },
      close_edit: function(){
        this.dialog_modal_message = true;
      },
      getModalAnswer(value){
        if(value){
          this.$store.dispatch('user/getUserList');
          this.$emit('update:dialog', false) 
        }
      },
      save: function(){

        this.data.beginning_date = this.beginDate; // = new Date(val.beginning_date); //.substr(0, val.beginning_date.indexOf('T'));
        this.data.ending_date = this.endDate;// = new Date(val.ending_date); //.substr(0, val.ending_date.indexOf('T'));

        if(this.form_type == 'addForm'){
          this.$store.dispatch('user/register',this.data);
        }

        if(this.form_type == 'editForm'){
          //console.log('EDIT ', this.data.user_functions);
          this.$store.dispatch('user/updateUser',this.data);
        }

        this.form_type = 'viewForm';
        this.$emit('update:dialog', false)
      }
    }
  }
</script>
<style>
  v-btn {
    padding: 2px;
  }
  .v-picker {
    width: 210px;
    height: 300px;
  }
  .v-date-picker-header{
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .v-date-picker-header__value div {
    width: 100%;
  }
  .v-picker__title {
    padding: 7px;
  }
  .v-date-picker-title {
    align-items: center;
  }
  .v-date-picker-table--date th {
    padding: 0px;
  }
  .v-date-picker-table th {
    font-size: 10px;
  }
  .v-picker__body  {
    width: 150px;
    height: 100px;
  }
  div.v-picker__body, div.v-picker-header {
    width: 210px;
  }
  .v-picker__body > div {
      position: relative;
      right: 43px;
      width: 70%;
  }
  .v-picker__title__btn {
    font-size: 10px;
  }
  .v-date-picker-header__value {
    font-size: 10px;
    width: 150px;
  }
  .v-date-picker-table {
    width: 210px;
    padding: 0px;
    height: 100px;
  }
  .v-btn--icon.v-size--default {
    height: 30px;
    width: 30px;
}
.v-btn--icon.v-size--default .v-icon {
    height: 15px;
    font-size: 15px;
    width: 15px;
}
.v-date-picker-table--date .v-btn {
    height: 20px;
    width: 20px;
}
.v-date-picker-table .v-btn {
  font-size: 10px;
}

</style>
